import React, { useContext, useEffect, useRef, useState } from 'react'
import './Guest_house_details.css'
import Breadcrumb_Comp from '../../common/common_components/breadcrumb_comp/Breadcrumb_Comp'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation } from 'swiper/modules';
import Pink_Btn from '../../common/common_btn/pink_btn/Pink_Btn';
import Guest_house_booking_modal from '../../common/modals/guest-house-booking-modal/Guest_house_booking_modal';
import Light_Black_Btn from '../../common/common_btn/light_black_btn/Light_Black_Btn';
import Guest_room_cancel_modal from '../../common/common_modal/cancel_reason_modal/Guest_room_cancel_modal';
import { useParams } from 'react-router-dom';
import { getBookingDetail, GetSingleRoom } from '../../../features/admin/room/slice';
import { useDispatch, useSelector } from 'react-redux';
import { IDS } from '../../../utils/IDS';
import { decodeId, formatDate, formatTimeAMPM } from '../../../utils/common';
import parse from 'html-react-parser';
import { Context } from '../../../utils/context';
import Login_Layout_Modal from '../../common/modals/login-signup-modals/Login_Layout_Modal';

const Guest_house_details = () => {

    const { id } = useParams();
    const room = useSelector((state) => state.stay.room.single_room);

    const breadcrumbs = [

        { label: "Explore", link: "/explore", active: false },
        { label: "Your Spiritual Stay", link: "/guest-house", active: false },
        {
            label: room?.name,
            link: `/guest-house-details/${room?.id}`,
            active: true,
        },
    ];
    const dispatch = useDispatch();
    const [currentImage, setCurrentImage] = useState(null);


    useEffect(() => {
        dispatch(GetSingleRoom(decodeId(id)));
    }, [dispatch, id]);

    useEffect(() => {
        if (room?.image) {
            setCurrentImage(IDS.IMG_URL + room.image);
        }
    }, [room]);



    const { signin } = useContext(Context);



    const images = [
        {
            image: "/assets/images/rooms/acroom.png"
        },
        {
            image: "/assets/images/rooms/acroom.png"
        },
        {
            image: "/assets/images/rooms/acroom.png"
        },
        {
            image: "/assets/images/rooms/acroom.png"
        },
        {
            image: "/assets/images/rooms/acroom.png"
        },
        {
            image: "/assets/images/rooms/acroom.png"
        },
        {
            image: "/assets/images/rooms/acroom.png"
        },
        {
            image: "/assets/images/rooms/acroom.png"
        },


    ]

    const [swiperInstance, setSwiperInstance] = useState(null);


    class Zoomable {
        constructor(element, config) {
            this.element = element;
            this.config = this._mergeConfig(config);

            const { initialZoom, minZoom, maxZoom } = this.config;

            this.zoomed = false;
            this.initialZoom = Math.max(Math.min(initialZoom, maxZoom), minZoom);
            this.zoom = this.initialZoom;

            this.img = element.querySelector(".zoomable__img");


            this.img.draggable = false;
            this.element.style.setProperty("--zoom", this.initialZoom);

            this._addEventListeners();
        }

        static get Default() {
            return Default;
        }

        _addEventListeners() {
            this.element.addEventListener("mouseenter", () =>
                this._handleMouseover()
            );
            this.element.addEventListener("mousemove", (evt) =>
                this._handleMousemove(evt)
            );
            this.element.addEventListener("mouseleave", () => this._handleMouseout());
            this.element.addEventListener("wheel", (evt) => this._handleWheel(evt));
        }

        _handleMouseover() {
            if (this.zoomed) {
                return;
            }

            this.element.classList.add("zoomable--zoomed");
            this.zoomed = true;
        }

        _handleMousemove(evt) {
            if (!this.zoomed) {
                return;
            }

            const elPos = this.element.getBoundingClientRect();
            const percentageX = `${((evt.clientX - elPos.left) * 100) /
                elPos.width}%`;
            const percentageY = `${((evt.clientY - elPos.top) * 100) /
                elPos.height}%`;

            this.element.style.setProperty("--zoom-pos-x", percentageX);
            this.element.style.setProperty("--zoom-pos-y", percentageY);
        }

        _handleMouseout() {
            if (!this.zoomed) {
                return;
            }

            this.element.style.setProperty("--zoom", this.initialZoom);
            this.element.classList.remove("zoomable--zoomed");
            this.zoomed = false;
        }

        _handleWheel(evt) {
            if (!this.zoomed) {
                return;
            }

            evt.preventDefault();

            const newZoom = this.zoom + evt.deltaY * (this.config.zoomSpeed * -1);
            const { minZoom, maxZoom } = this.config;

            this.zoom = Math.max(Math.min(newZoom, maxZoom), minZoom);
            this.element.style.setProperty("--zoom", this.zoom);
        }

        _mergeConfig(config) {
            return {
                ...this.constructor.Default,
                ...(typeof config === "object" ? config : {}),
            };
        }
    }

    const Default = {
        initialZoom: 3,
        minZoom: 1.25,
        maxZoom: 4,
        zoomSpeed: 0.01,
    };

    const zoomableRef = useRef(null);

    useEffect(() => {
        const element = zoomableRef.current;
        if (!element) return;

        const zoomable = new Zoomable(element);

        return () => {
            element.removeEventListener("mouseenter", zoomable._handleMouseover);
            element.removeEventListener("mousemove", zoomable._handleMousemove);
            element.removeEventListener("mouseleave", zoomable._handleMouseout);
            element.removeEventListener("wheel", zoomable._handleWheel);
        };
    }, []);

    const [bookingModal, setBookingModal] = useState(false);
    const [cancelModal, setCancelModal] = useState(false);
    const [modelType, setModelType] = useState("");
    const [selectLogin, setSelectLogin] = useState(false);
    const [booking, setBooking] = useState({});
    const totalGuests = Number(booking?.guests_count || 0);
    const extraGuests = Number(booking?.extra_guest_count || booking?.extra_persons || 0);
    const baseGuests = Math.max(totalGuests - extraGuests, 0);
    const extraCharge = Number(booking?.Room?.extra_person_charge || 0);


    const getBookingDetails = async () => {
        const res = await dispatch(getBookingDetail(decodeId(id)));
        if (res?.payload) {
            setBooking(res?.payload?.data);
        }
    }

    useEffect(() => { getBookingDetails(id) }, [id]);

    const GOTOBOOK = async () => {

        if (!signin) {
            setModelType("select_login");
            setSelectLogin(true);
        } else {
            setBookingModal(true)
        }
    }



    return (
        <>
            <div className='container'>
                <Breadcrumb_Comp data={breadcrumbs} />
                <div className='Guest_house_details_sec'>
                    <div className='row'>
                        <div className='col-12 my-3'>
                            <h5 className='roomtitle'>{room?.name || ""}</h5>
                        </div>
                        <div className='col-lg-6 mb-lg-0 mb-4'>
                            <div className='room_images_sec'>
                                <div className='Product_Image'>
                                    <div className='img_main_container'>
                                        <div className="product-detail text-center">
                                            <div className="specs" ref={zoomableRef}>
                                                <img
                                                    src={process.env.PUBLIC_URL + currentImage}
                                                    className="zoomable__img"
                                                    alt="Selected"
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="main">
                                        <div className="sidebar-swiper">
                                            <Swiper
                                                slidesPerView={"auto"}
                                                autoplay={{
                                                    delay: 2000,
                                                    disableOnInteraction: false,
                                                }}
                                                modules={[Navigation, Autoplay]}
                                                breakpoints={{
                                                    0: {
                                                        slidesPerView: 2,
                                                        spaceBetween: 5,
                                                    },
                                                    380: {
                                                        slidesPerView: 3,
                                                        spaceBetween: 5,
                                                    },
                                                    485: {
                                                        slidesPerView: 3,
                                                        spaceBetween: 5,
                                                    },
                                                    575: {
                                                        slidesPerView: 3,
                                                        spaceBetween: 5,
                                                    },

                                                    768: {
                                                        slidesPerView: 3,
                                                        spaceBetween: 5,
                                                    },
                                                    992: {
                                                        slidesPerView: 3,
                                                        spaceBetween: 5,
                                                    },
                                                    1024: {
                                                        slidesPerView: 3,
                                                        spaceBetween: 5,
                                                    },
                                                    1200: {
                                                        slidesPerView: 3,
                                                        spaceBetween: 5,
                                                    },

                                                }}
                                                navigation
                                                pagination={{ clickable: true }}
                                                className="mySwiper category_slider product_image_slider"
                                                onSwiper={(swiper) => setSwiperInstance(swiper)}
                                            >
                                                {room?.images?.map((item, index) => (
                                                    <SwiperSlide key={index}>
                                                        <div
                                                            className="gallery-imgs"
                                                            onClick={() => setCurrentImage(IDS.IMG_URL + item.image)}

                                                        >
                                                            <img
                                                                src={IDS.IMG_URL + item.image}
                                                                className="inner-img"
                                                                alt={`Image ${index + 1}`}
                                                            />
                                                        </div>
                                                    </SwiperSlide>
                                                ))}
                                            </Swiper>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-lg-6'>
                            <div className='room_desc'>
                                <h6 className='facih6'>Facilities:</h6>
                                <div className='row'>
                                    {room?.Facilities?.map((facility) => (
                                        <div className='col-sm-6 col-12 mb-3'>
                                            <div className='facdiv'>
                                                <div className='icondiv bgcol'>
                                                    <img className='icon' src={IDS.IMG_URL + facility?.image} />
                                                </div>
                                                <div className='namediv'>
                                                    <p className='facp'>{facility?.name || ""}</p>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>


                                <h6 className='facih6 mt-3'>Timings:</h6>
                                <div className='row'>
                                    <div className='col-sm-6 col-12 mb-3'>
                                        <div className='facdiv'>
                                            <div className='icondiv bgco2'>
                                                <img className='icon' src={process.env.PUBLIC_URL + '/assets/images/rooms/check-in.png'} />
                                            </div>
                                            <div className='namediv namebg'>
                                                <p className='facp'>Check In : {formatTimeAMPM(room?.check_in_time) || ""}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-sm-6 col-12 mb-3'>
                                        <div className='facdiv'>
                                            <div className='icondiv bgco2'>
                                                <img className='icon' src={process.env.PUBLIC_URL + '/assets/images/rooms/check-out.png'} />
                                            </div>
                                            <div className='namediv namebg'>
                                                <p className='facp'>Check out : {formatTimeAMPM(room?.check_out_time) || ""}</p>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                                <hr></hr>

                                <div className='prisediv'>
                                    <div className='row'>
                                        {!booking && !booking?.id && <>
                                            <div className='col-6'>
                                                <p className='prisepp'>Price: ₹{room?.price || ""}</p>
                                            </div>
                                            <div className='col-6 text-end'>
                                                <Pink_Btn btnText={'Book'} onClick={() => GOTOBOOK()} />
                                            </div>
                                        </>
                                        }
                                    </div>
                                </div>


                            </div>


                            {booking && booking?.id && <div className='cancekbookingsec'>
                                <h6 className='bookh6'><img src={process.env.PUBLIC_URL + '/assets/images/rooms/rm.png'} />Booking Details</h6>
                                <p className='scp'><img src={process.env.PUBLIC_URL + '/assets/images/rooms/schedule.png'} />Date and Time:</p>

                                <div className='datescsec'>
                                    <div className='row mb-3'>
                                        <div className='col-5 pe-0'>
                                            <div className='datediv'>
                                                <p className='datep'><span>Start Date:</span> {formatDate(booking?.check_in_date)}</p>
                                            </div>
                                        </div>
                                        <div className='col-2 my-auto p-0'>
                                            <img className='line' src={process.env.PUBLIC_URL + '/assets/images/rooms/line.png'} />
                                        </div>
                                        <div className='col-5 ps-0'>
                                            <div className='datediv'>
                                                <p className='datep'><span>End Date:</span> {formatDate(booking?.check_out_date)}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='row mb-3'>
                                        <div className='col-5 pe-0'>
                                            <div className='datediv'>
                                                <p className='datep'><span>Start Time:</span> {formatTimeAMPM(booking?.check_in_time)}</p>
                                            </div>
                                        </div>
                                        <div className='col-2 my-auto p-0'>
                                            <img className='line' src={process.env.PUBLIC_URL + '/assets/images/rooms/line.png'} />
                                        </div>
                                        <div className='col-5 ps-0'>
                                            <div className='datediv'>
                                                <p className='datep'><span>End Time:</span> {formatTimeAMPM(booking?.check_out_time)}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div className='prisediv'>
                                    <div className='row'>
                                        <div className='col-sm-6'>
                                            <p className='scp'><img src={process.env.PUBLIC_URL + '/assets/images/rooms/users.png'} />Room Accommodation For:</p>
                                            <p className='scp'>Room Accommodation for {booking?.guests_count - booking?.extra_guest_count} Guest {booking?.extra_guest_count > 0 ? `+ ${booking?.extra_guest_count} ` : ""}</p>
                                            <p className='scp'>*extra charges applied (₹.{Number(booking?.Room?.extra_person_charge || "0")}/Extra Person)</p>

                                        </div>
                                        {booking?.booking_statuse_id !== 6 && booking?.booking_statuse_id !== 3}
                                        <div className='col-sm-6 text-end mt-auto'>
                                            {/* <Pink_Btn btnText={'Book'} onClick={() => setBookingModal(true)} /> */}
                                            <Light_Black_Btn btnText={'Cancel Booking'} onClick={() => setCancelModal(true)} />
                                        </div>
                                    </div>
                                </div>
                            </div>}
                        </div>
                    </div>

                    <div className='rulesdiv'>
                        {parse(room?.description || "") || ""}
                    </div>
                    <div className='rulesdiv'>
                        {parse(room?.rules_policies || "") || ""}
                    </div>
                </div>


                <Guest_house_booking_modal
                    room={room}
                    show={bookingModal}
                    onHide={() => setBookingModal(false)}
                />

                <Guest_room_cancel_modal
                    booking_id={booking?.id}
                    getBookingDetails={getBookingDetails}
                    show={cancelModal}
                    onHide={() => setCancelModal(false)}
                    modal_title={'Reason for Cancelling'}
                />

                <Login_Layout_Modal
                    modalType={modelType}
                    show={selectLogin}
                    onHide={() => setSelectLogin(false)}
                />
            </div>
        </>
    )
    // return (
    //     <>
    //         <div className='container'>
    //             <Breadcrumb_Comp data={breadcrumbs} />
    //             <div className='Guest_house_details_sec'>
    //                 <div className='row'>
    //                     <div className='col-12 my-3'>
    //                         <h5 className='roomtitle'>AC room ideal for 2 guests</h5>
    //                     </div>
    //                     <div className='col-lg-6 mb-lg-0 mb-4'>
    //                         <div className='room_images_sec'>
    //                             <div className='Product_Image'>
    //                                 <div className='img_main_container'>
    //                                     <div className="product-detail text-center">
    //                                         <div className="specs" ref={zoomableRef}>
    //                                             <img
    //                                                 src={process.env.PUBLIC_URL + currentImage}
    //                                                 className="zoomable__img"
    //                                                 alt="Selected"
    //                                             />
    //                                         </div>
    //                                     </div>
    //                                 </div>

    //                                 <div className="main">
    //                                     <div className="sidebar-swiper">
    //                                         <Swiper
    //                                             slidesPerView={"auto"}
    //                                             autoplay={{
    //                                                 delay: 2000,
    //                                                 disableOnInteraction: false,
    //                                             }}
    //                                             modules={[Navigation, Autoplay]}
    //                                             breakpoints={{
    //                                                 0: {
    //                                                     slidesPerView: 2,
    //                                                     spaceBetween: 5,
    //                                                 },
    //                                                 380: {
    //                                                     slidesPerView: 3,
    //                                                     spaceBetween: 5,
    //                                                 },
    //                                                 485: {
    //                                                     slidesPerView: 3,
    //                                                     spaceBetween: 5,
    //                                                 },
    //                                                 575: {
    //                                                     slidesPerView: 3,
    //                                                     spaceBetween: 5,
    //                                                 },

    //                                                 768: {
    //                                                     slidesPerView: 3,
    //                                                     spaceBetween: 5,
    //                                                 },
    //                                                 992: {
    //                                                     slidesPerView: 3,
    //                                                     spaceBetween: 5,
    //                                                 },
    //                                                 1024: {
    //                                                     slidesPerView: 3,
    //                                                     spaceBetween: 5,
    //                                                 },
    //                                                 1200: {
    //                                                     slidesPerView: 3,
    //                                                     spaceBetween: 5,
    //                                                 },

    //                                             }}
    //                                             navigation
    //                                             pagination={{ clickable: true }}
    //                                             className="mySwiper category_slider product_image_slider"
    //                                             onSwiper={(swiper) => setSwiperInstance(swiper)}
    //                                         >
    //                                             {room?.images?.map((item, index) => (
    //                                                 <SwiperSlide key={index}>
    //                                                     <div
    //                                                         className="gallery-imgs"
    //                                                         onClick={() => setCurrentImage(IDS.IMG_URL + item.image)}

    //                                                     >
    //                                                         <img
    //                                                             src={IDS.IMG_URL + item.image}
    //                                                             className="inner-img"
    //                                                             alt={`Image ${index + 1}`}
    //                                                         />
    //                                                     </div>
    //                                                 </SwiperSlide>
    //                                             ))}
    //                                         </Swiper>

    //                                     </div>
    //                                 </div>
    //                             </div>
    //                         </div>
    //                     </div>

    //                     <div className='col-lg-6'>
    //                         <div className='room_desc'>
    //                             <h6 className='facih6'>Facilities:</h6>
    //                             <div className='row'>


    //                                 <div className='col-sm-6 col-12 mb-3'>
    //                                     <div className='facdiv'>
    //                                         <div className='icondiv bgcol'>
    //                                             <img className='icon' src={process.env.PUBLIC_URL + '/assets/images/rooms/food-service.png'} />
    //                                         </div>
    //                                         <div className='namediv'>
    //                                             <p className='facp'>Food Facility: No</p>
    //                                         </div>
    //                                     </div>
    //                                 </div>
    //                                 <div className='col-sm-6 col-12 mb-3'>
    //                                     <div className='facdiv'>
    //                                         <div className='icondiv bgcol'>
    //                                             <img className='icon' src={process.env.PUBLIC_URL + '/assets/images/rooms/food-service.png'} />
    //                                         </div>
    //                                         <div className='namediv'>
    //                                             <p className='facp'>bottel.png</p>
    //                                         </div>
    //                                     </div>
    //                                 </div>
    //                                 <div className='col-sm-6 col-12 mb-3'>
    //                                     <div className='facdiv'>
    //                                         <div className='icondiv bgcol'>
    //                                             <img className='icon' src={process.env.PUBLIC_URL + '/assets/images/rooms/geyser.png'} />
    //                                         </div>
    //                                         <div className='namediv'>
    //                                             <p className='facp'>Geyser</p>
    //                                         </div>
    //                                     </div>
    //                                 </div>
    //                                 <div className='col-sm-6 col-12 mb-3'>
    //                                     <div className='facdiv'>
    //                                         <div className='icondiv bgcol'>
    //                                             <img className='icon' src={process.env.PUBLIC_URL + '/assets/images/rooms/toilet.png'} />
    //                                         </div>
    //                                         <div className='namediv'>
    //                                             <p className='facp'>Attached Toilet</p>
    //                                         </div>
    //                                     </div>
    //                                 </div>
    //                             </div>


    //                             <h6 className='facih6 mt-3'>Timings:</h6>
    //                             <div className='row'>
    //                                 <div className='col-sm-6 col-12 mb-3'>
    //                                     <div className='facdiv'>
    //                                         <div className='icondiv bgco2'>
    //                                             <img className='icon' src={process.env.PUBLIC_URL + '/assets/images/rooms/check-in.png'} />
    //                                         </div>
    //                                         <div className='namediv namebg'>
    //                                             <p className='facp'>Check In : 8:00 am</p>
    //                                         </div>
    //                                     </div>
    //                                 </div>
    //                                 <div className='col-sm-6 col-12 mb-3'>
    //                                     <div className='facdiv'>
    //                                         <div className='icondiv bgco2'>
    //                                             <img className='icon' src={process.env.PUBLIC_URL + '/assets/images/rooms/check-out.png'} />
    //                                         </div>
    //                                         <div className='namediv namebg'>
    //                                             <p className='facp'>Check out : 12:00 am</p>
    //                                         </div>
    //                                     </div>
    //                                 </div>

    //                             </div>

    //                             <hr></hr>

    //                             <div className='prisediv'>
    //                                 <div className='row'>
    //                                     <div className='col-6'>
    //                                         <p className='prisepp'>Price: ₹1180</p>
    //                                     </div>
    //                                     <div className='col-6 text-end'>
    //                                         <Pink_Btn btnText={'Book'} onClick={() => setBookingModal(true)} />
    //                                     </div>
    //                                 </div>
    //                             </div>


    //                         </div>


    //                         <div className='cancekbookingsec'>
    //                             <h6 className='bookh6'><img src={process.env.PUBLIC_URL + '/assets/images/rooms/rm.png'} />Booking Details</h6>
    //                             <p className='scp'><img src={process.env.PUBLIC_URL + '/assets/images/rooms/schedule.png'} />Date and Time:</p>

    //                             <div className='datescsec'>
    //                                 <div className='row mb-3'>
    //                                     <div className='col-5 pe-0'>
    //                                         <div className='datediv'>
    //                                             <p className='datep'><span>Start Date:</span> 18.JUN.25</p>
    //                                         </div>
    //                                     </div>
    //                                     <div className='col-2 my-auto p-0'>
    //                                         <img className='line' src={process.env.PUBLIC_URL + '/assets/images/rooms/line.png'} />
    //                                     </div>
    //                                     <div className='col-5 ps-0'>
    //                                         <div className='datediv'>
    //                                             <p className='datep'><span>End Date:</span> 20.JUN.25</p>
    //                                         </div>
    //                                     </div>
    //                                 </div>
    //                                 <div className='row mb-3'>
    //                                     <div className='col-5 pe-0'>
    //                                         <div className='datediv'>
    //                                             <p className='datep'><span>Start Time:</span> 10:00am</p>
    //                                         </div>
    //                                     </div>
    //                                     <div className='col-2 my-auto p-0'>
    //                                         <img className='line' src={process.env.PUBLIC_URL + '/assets/images/rooms/line.png'} />
    //                                     </div>
    //                                     <div className='col-5 ps-0'>
    //                                         <div className='datediv'>
    //                                             <p className='datep'><span>End Time:</span> 12:30 pm</p>
    //                                         </div>
    //                                     </div>
    //                                 </div>
    //                             </div>


    //                             <div className='prisediv'>
    //                                 <div className='row'>
    //                                     <div className='col-sm-6'>
    //                                         <p className='scp'><img src={process.env.PUBLIC_URL + '/assets/images/rooms/users.png'} />Room Accommodation For:</p>
    //                                         <p className='scp'>Room Accommodation for 2 + 1</p>
    //                                         <p className='scp'>*extra charges applied (₹.112.00/Extra Person)</p>

    //                                     </div>
    //                                     <div className='col-sm-6 text-end mt-auto'>
    //                                         {/* <Pink_Btn btnText={'Book'} onClick={() => setBookingModal(true)} /> */}
    //                                         <Light_Black_Btn btnText={'Cancel Booking'} onClick={() => setCancelModal(true)} />
    //                                     </div>
    //                                 </div>
    //                             </div>
    //                         </div>
    //                     </div>
    //                 </div>

    //                 <div className='rulesdiv'>
    //                     <h5>Rules & Policies:</h5>
    //                     <ul>
    //                         <li>Extra Bed Policy:
    //                             <p className='subli'>Extra Person Not Allowed.</p>
    //                         </li>
    //                         <li>Check-In Restrictions:
    //                             <p className='subli'>Only Family Allowed.</p>
    //                             <p className='subli'>Single person is strictly not allowed.</p>
    //                         </li>
    //                         <li>ID Proof Related:
    //                             <p className='subli'>Aadhar, Driving License, Passport and Govt. </p>
    //                             <p className='subli'>IDs are accepted as ID proof(s).</p>
    //                         </li>
    //                         <li>Property Accessibility:
    //                             <p className='subli'>Parking facility available inside the premises area.</p>
    //                         </li>
    //                         <li>Pet(s) Related:
    //                             <p className='subli'>Pets are not allowed.</p>
    //                         </li>
    //                     </ul>
    //                 </div>
    //             </div>


    //             <Guest_house_booking_modal
    //                 show={bookingModal}
    //                 onHide={() => setBookingModal(false)}
    //             />

    //             <Guest_room_cancel_modal
    //                 show={cancelModal}
    //                 onHide={() => setCancelModal(false)}
    //                 modal_title={'Reason for Cancelling'}
    //             />
    //         </div>
    //     </>
    // )
}

export default Guest_house_details